'use strict';

var ScenarioListDirective = function ScenarioListDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/scenario-list.html'),
    scope: {
      scenarioPermission: '@?'
    },
    controller: 'ScenarioListController',
    link: function link(scope) {
      scope.$on('scenarios:loaded', scope.loadScenarioList);
      scope.$on('scenarios:changed', scope.scenarioChanged);
    }
  };
};
module.exports = ScenarioListDirective;